import {animate, AnimationStateMetadata, AnimationTransitionMetadata, state, style, transition} from '@angular/animations';

export enum StateAnimation {IN = 'in'}

export class CustomAnimations {
    public static fadeAnimation(timer = 500): [AnimationStateMetadata, AnimationTransitionMetadata, AnimationTransitionMetadata] {
        return [
            state(StateAnimation.IN, style({opacity: 1})),
            transition(':enter', [style({opacity: 0}), animate(timer)]),
            transition(':leave', animate(100, style({opacity: 0})))
        ];
    }
}
